// extracted by mini-css-extract-plugin
export default {"container":"LearnWin_container__Qs+3C","heading":"LearnWin_heading__bMmpV","subheading":"LearnWin_subheading__glNXJ","grid":"LearnWin_grid__Z2uSo","card":"LearnWin_card__UCz5x"};